var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("router-link", { attrs: { tag: "li", to: _vm.customLink } }, [
    _c("a", [_vm._v(_vm._s(_vm.item.name))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/EventCategory.vue